import React from "react";

function Loader({ message = "Loading..." }) {
  return (
    <div className="loader-container">
      <div className="loader-ring">
        <div className="loader-logo-circle">
          <img src="/static/img/logo.png" alt="Loading" className="loader-logo" />
        </div>
      </div>
      <p className="loader-message">{message}</p>
    </div>
  );
}

export default Loader;
